import { compose, noop } from 'lodash/fp';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { commanderForm, presence, validation } from '@mews-commander/legacy-form';
import { checkOut } from '../../../actions';
import { getCheckOutWithUnbalancedBillValue, getInitialValues } from './selectors';
import { CheckOutFormValues } from './types';

const getConstraints = ({ showReason }: $TSFixMe) => ({
    reason: showReason ? { presence } : {},
});

interface StateProps {
    showReason: boolean;
    initialValues: Pick<CheckOutFormValues, 'closeBalancedBills'>;
}

interface DispatchProps {
    onSubmit: ({ reason, closeBalancedBills, checkOutWithUnbalancedBill }: CheckOutFormValues) => Promise<void>;
}

interface OwnProps {
    reservationIds: string[];
    form: string;
    onSuccess: () => void;
}

const connectForm = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        showReason: getCheckOutWithUnbalancedBillValue,
        initialValues: (state, { reservationIds }) => getInitialValues(state, { ids: reservationIds }),
    }),
    (dispatch: CommanderThunkDispatch, { reservationIds, onSuccess = noop }) => ({
        onSubmit: async ({ reason, closeBalancedBills, checkOutWithUnbalancedBill }) =>
            dispatch(checkOut({ reservationIds, closeBalancedBills, checkOutWithUnbalancedBill, reason })).then(() => {
                showSuccessAlert({ description: lt('ReservationCheckOutSuccessMessage') });
                onSuccess();
            }),
    })
);

export const injectReservationModuleForm = compose(
    connectForm,
    commanderForm({
        enableReinitialize: true,
        submitLabel: <LocalizedText textKey={TextKey.CheckOut} />,
        submitButtonProps: {
            'data-test-id': DataTestId.CheckOutButton,
        },
        validate: validation(getConstraints),
    })
);

export const injectSmartDetailForm = compose(
    connectForm,
    reduxForm({
        enableReinitialize: true,
        validate: validation(getConstraints),
    })
);
